import axios from "axios";

const ENDPOINT_KEY = "campaigns";
const ENDPOINT_URI = "/campaign";

export default function useCampaignService() {
  return {
    queryKey: ENDPOINT_KEY,
    getCampaigns: async (search = "", page = 1, limit = 10) => {
      const params = new URLSearchParams({
        page,
        limit,
      });
      if (search) {
        params.append("search", search);
      }
      const response = await axios.get(`${ENDPOINT_URI}/`, { params });
      return response.data.payload;
    },
    getCampaignById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    addCampaign: async ({ payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}/`, payload);
      return response.data.payload;
    },
    updateCampaign: async ({ id, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    deleteCampaign: async (id) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    getCampaignsWithoutPagination: async () => {
      const allCampaigns = [];
      let page = 1;
      let limit = 1000;
      while (true) {
        const { data } = await axios.get(`${ENDPOINT_URI}/`, {
          params: { page, limit },
        });
        allCampaigns.push(...[...data?.payload?.campaigns]);
        if (page >= data?.payload?.totalPages) {
          break;
        }
        page++;
      }
      return allCampaigns;
    }
  };
}
